var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C2.065 0 0.5 1.565 0.5 3.5C0.5 6.125 4 10 4 10C4 10 7.5 6.125 7.5 3.5C7.5 1.565 5.935 0 4 0ZM4 4.75C3.31 4.75 2.75 4.19 2.75 3.5C2.75 2.81 3.31 2.25 4 2.25C4.69 2.25 5.25 2.81 5.25 3.5C5.25 4.19 4.69 4.75 4 4.75Z",
    fill: "#73788C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.8a2dc7d9ac112231e1c1f439f0b4ac73.svg";
export { ForwardRef as ReactComponent };